import { useQuery } from "@tanstack/react-query";

import { JOBS_POLLING_INTERVAL_MS } from "app/pages/sales-intelligence/modules/crm-enrichment/constants";
import { useCrmEnrichmentJobsDataSync } from "app/pages/sales-intelligence/modules/crm-enrichment/hooks/useCrmEnrichmentJobsDataSync";

import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

import { hubspotEnrichmentQueryKeys } from "./queryKeyFactory";

type Options = {
    enabled?: boolean;
    polling?: boolean;
};

const useHsEnrichmentJobsQuery = ({ enabled = true, polling = false }: Options = {}) => {
    const queryOptions = polling
        ? {
              refetchInterval: JOBS_POLLING_INTERVAL_MS,
              refetchIntervalInBackground: false,
              refetchOnMount: "always" as const,
              staleTime: 0,
              gcTime: 0,
          }
        : {};

    const query = useQuery({
        queryKey: hubspotEnrichmentQueryKeys.jobs(),
        queryFn({ signal }) {
            return hubspotEnrichmentAPIService.getJobs({
                cancellation: signal,
            });
        },
        enabled,
        ...queryOptions,
    });

    useCrmEnrichmentJobsDataSync(query.data, hubspotEnrichmentQueryKeys);

    return query;
};

export default useHsEnrichmentJobsQuery;
